import type { TMessages } from '@/types/TMessages'
import { ADVANCE_PAYMENT_CALCULATOR_MIN_LOAN_PERIOD_IN_DAYS } from './constants'

export const messages = {
  field: {
    advanceAmount: {
      label: 'Укажите желаемый размер аванса',
      postfix: 'руб.',
      error: {
        min: 'Минимальная сумма аванса - {minValue} руб. Пожалуйста, попробуйте рассчитать аванс с другими параметрами',
        max: 'Максимальная сумма аванса - {maxValue} руб. Пожалуйста, попробуйте рассчитать аванс с другими параметрами',
      },
    },
    elevator: {
      label: 'Элеватор поставки',
      placeholder: 'Выберите элеватор поставки',
      button: {
        onMap: 'На карте',
      },
    },
    advancePaymentDate: {
      label: 'Дата выдачи аванса',
      placeholder: 'Выберите дату',
    },
    productDeliveryDate: {
      label: 'Дата начала поставки товара',
      placeholder: 'Выберите дату',
      error: {
        outOfRange: 'Поле.рф не выдает займы меньше, чем на 30 дней. Пожалуйста, попробуйте рассчитать кредит с другими параметрами.',
      },
    },
    daysUntilHarvestDelivery: {
      label: 'Срок до поставки урожая',
    },
  },
  button: {
    openMap: 'На карте',
  },
  error: {
    required: 'Необходимо заполнить',
    datesOutOfRange: `Поле.рф не выдает займы меньше, чем на ${ADVANCE_PAYMENT_CALCULATOR_MIN_LOAN_PERIOD_IN_DAYS} дней. Пожалуйста попробуйте рассчитать кредит с другими параметрами.`,
  },
} satisfies TMessages
